/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["label.spatial-relationship span{display:inline-block;padding-top:11px}label.spatial-relationship select{float:right}"];
export { styles as styles };
